import React from "react";
// import "./NotFound.scss";

export default function NotFound() {
  return "not found ";
}
